import TreatmentDetail from "@/pages/treatment/components/TreatmentDetail";
import { getTreatmentPage } from "@/mocks/treatmentPages";

export default function SkinManagementPage() {
  const data = getTreatmentPage("skin-management");
  if (!data) return null;
  return <TreatmentDetail data={data} />;
}